<template>
  <div class="page_list">
    <template v-if="total > pageSize">
      <div class="a" @click="currentChange(1)">
        <img src="../assets/images/leftdd.png"/>
      </div>
      <el-pagination :page-size="pageSize" @current-change="currentChange"
        :current-page="currentPage" layout="prev, pager, next" :total="total" :pager-count="isPc ? 7 : 3">
      </el-pagination>
      <div class="a" @click="currentChange(Math.ceil(total/pageSize))">
        <img src="../assets/images/rightdd.png"/>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'foot',
    props: {
      total: Number,
      currentPage: Number,
      pageSize: {
        default: 10,
        type: Number
      }
    },
    methods: {
      currentChange(e) {
        this.$emit('currentChange', e)
      }
    }
  }
</script>
<style lang='less' scoped>
@media screen and (min-width: 769px) {
  .page_list {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.04rem;

    /deep/ .el-pagination button:hover {
      color: #fc581c;
    }

    /deep/ .el-pagination button:disabled {
      background-color: initial;
    }

    /deep/ .el-pagination .btn-next {
      background: center center no-repeat !important;
      
      i {
        font-size: 20px;
      }
    }

    /deep/ .el-pagination .btn-prev {
      background: center center no-repeat !important;
      
      i {
        font-size: 20px;
      }
    }

    /deep/ .el-pager li {
      background-color: initial;
      font-size: 20px;
    }

    /deep/.el-pager li.active {
      color: #DA4F30;
    }

    .a {
      font-size: .28rem;
      font-family: syn;
      padding: 0 .14rem;
      transition: all .1s;
      color: #666666;
      display: flex;
      cursor: pointer;
			img{
				width: 20px;
			}
      &.on {
        color: #DA4F30;
      }

      &:hover {
        color: #DA4F30;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .page_list {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.04rem;

    /deep/ .el-pagination button:hover {
      color: #fc581c;
    }

    /deep/ .el-pagination button:disabled {
      background-color: initial;
    }

    /deep/ .el-pagination .btn-next {
      background: center center no-repeat !important;
      
      i {
        font-size: .24rem;
      }
    }

    /deep/ .el-pagination .btn-prev {
      background: center center no-repeat !important;
      
      i {
        font-size: .24rem;
      }
    }

    /deep/ .el-pager li {
      background-color: initial;
      font-size: .24rem;
    }

    /deep/.el-pager li.active {
      color: #DA4F30;
    }

    .a {
      font-size: .28rem;
      font-family: syn;
      padding: 0 .14rem;
      transition: all .1s;
      color: #666666;
      display: flex;
      cursor: pointer;
			img{
				width: .24rem;
			}
      &.on {
        color: #DA4F30;
      }

      &:hover {
        color: #DA4F30;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue